import { call, takeLatest, put, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ rejectionReasonParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'rejectionreason/getsearched',
      params: rejectionReasonParams,
    });
    const allRejectionReasons = data;
    yield put(Actions.setAll({ allRejectionReasons }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', error);
    console.warn(error);
  }
}

function* fetchAllRejectionReasons() {
  try {
    const { data } = yield call(api.get, {
      route: 'rejectionreason',
    });
    const allRejectionReasonsData = data;
    yield put(Actions.setAllRejectionReasons({ allRejectionReasonsData }));
  } catch (error) {
    notification('error', error);
    console.warn(error);
  }
}

function* addOrUpdateRejectionReason({ rejectionReasonData, actionName, rejectionReasonParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: 'rejectionReason',
      data: rejectionReasonData,
    });
    yield put(Actions.fetchAll({ rejectionReasonParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.REJECTION_REASON_CREATED
        : CONSTANT_VARIABLES.REJECTION_REASON_UPDATED,
      ''
    );
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    const message = CONSTANT_VARIABLES.REJECTION_REASON_SAVE_FAILED;
    notification('error', message);
    console.warn(error);
  }
}

function* deleteRejectionReason({ id, rejectionReasonParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, { route: 'rejectionReason/' + id });
    yield put(Actions.fetchAll({ rejectionReasonParams }));

    notification('success', CONSTANT_VARIABLES.REJECTION_REASON_DELETED, '');
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    const message = CONSTANT_VARIABLES.REJECTION_REASON_DELETE_FAILED;
    notification('error', message);
    console.warn(error);
  }
}
function* changeIsPriority({ id, isPriority, rejectionReasonParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, { route: 'rejectionReason/changeIsPriority/' + id + '/' + isPriority });
    yield put(Actions.fetchAll({ rejectionReasonParams }));

    notification('success', CONSTANT_VARIABLES.REJECTION_REASON_IS_PRIORITY_CHANGED, '');
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchAll({ rejectionReasonParams }));
    notification('error', 'Not allowed to add more than 10 rejection reason');
    console.warn(error);
  }
}
function* canAddIsPriority({ id }) {
  try {
    yield put(Actions.setIsLoadingCanAddPriority({ isLoadingCanAddPriority: true }));
    const result = yield call(api.get, { route: 'rejectionReason/CanAddIsPriority/' + id });
    yield put(Actions.setCanAddIsPriority({ canAddIsPriority: result.data }));
    yield put(Actions.setIsLoadingCanAddPriority({ isLoadingCanAddPriority: false }));
  } catch (error) {
    yield put(Actions.setIsLoadingCanAddPriority({ isLoadingCanAddPriority: false }));
    notification('error', 'error in loading for rejection reason priority!');
    console.warn(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.FETCH_ALL_REJECTION_REASONS, fetchAllRejectionReasons),
    takeLatest(ActionTypes.ADD_OR_UPDATE_REJECTION_REASON, addOrUpdateRejectionReason),
    takeLatest(ActionTypes.DELETE_REJECTION_REASON, deleteRejectionReason),
    takeLatest(ActionTypes.CHANGE_IS_PRIORITY_REJECTION_REASON, changeIsPriority),
    takeLatest(ActionTypes.CAN_ADD_IS_PRIORITY_REJECTION_REASON, canAddIsPriority),
  ]);
}
